import { Button, Form, Input, Radio, Select } from 'antd';
import { getSourceDownload, SourcePayload } from 'api/master';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SourceList from '../SourceList';
// import xlsx from 'json-as-xlsx';
// import { download, generateCsv, mkConfig } from 'export-to-csv';
import xlsx from 'json-as-xlsx';
import { FileExcelFilled } from '@ant-design/icons';

type Props = {
  isLoading: boolean;
  onSubmit: (values: SourcePayload) => Promise<void>;
};

const filterPayload: SourcePayload = {};

const Source = ({ onSubmit }: Props) => {
  const { Option } = Select;
  const navigate = useNavigate();
  const [filter, setFilter] = useState(filterPayload);
  const [form] = Form.useForm<SourcePayload>();
  //const [source, setSource] = useState('');

  const handleSubmit = useCallback(
    async (values: SourcePayload) => {
      debugger;
      let updatedValues = { ...values };
      updatedValues.Username = sessionStorage.getItem('user')?.toString();
      setFilter(updatedValues);
      //form.resetFields();
    },
    [onSubmit, form]
  );

  const handleSource = () => {
    navigate('/master/source/add');
  };
  type PayloadData = {
    SourceApplicationName?: string;
    TypeofApplication?: string;
    IsActive?: string;
    isExtract?: boolean;
    pageNo?: number;
    pageSize?: number;
    isActive?: boolean;
  };
  function handleDownload(_e: any) {
    filter.isExtract = true;
    filter.PageNo = 1;
    filter.PageSize = 10;

    const values: PayloadData = form.getFieldsValue();
    const filteredValues: PayloadData = {
      ...values,
    };

    getSourceDownload(filteredValues).then((_x) => {
      let settings = {
        fileName: 'Source Master -Report', // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };
      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index) => ({
        ...item,

        SourceApplicationName: item.SourceApplicationName,
        LoanTypes: item.LoanTypes,
        TypeOfapplication: item.TypeOfApplication,
        SecretKey: item.SecretKey,
        CreatedDate: item.CreatedDate,
        isActive: item.isActive,
        ROWNUM: index + 1,
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'Source Application Name', value: 'SourceApplicationName' },
            { label: 'LoanTypes', value: 'LoanTypes' },

            { label: 'Type of Application	', value: 'TypeOfapplication' },
            { label: 'Secret Key', value: 'SecretKey' },
            { label: 'Created On', value: 'CreatedDate' },
            { label: 'Is Active', value: 'isActive' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Source Master</h2>
              <div className="submission-htmlForm" style={{ overflow: 'hidden' }}>
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<SourcePayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={
                    {
                      //['Username']: sessionStorage.getItem('user')?.toString(),
                    }
                  }
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Source Application Name :'}
                          name="SourceApplicationName"
                          className="fieldTitle"
                        >
                          <Input placeholder={'Source Application Name'} defaultValue="" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Type of Application :'}
                          name="TypeofApplication"
                          className="fieldTitle"
                        >
                          <Select
                            defaultValue={'Select'}
                            size="large"
                            //value={statusId.toString()}
                            //onSelect={handleStatusId}
                          >
                            <Option value="Mobile">Mobile</Option>
                            <Option value="Web">Web</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Type :'} name="IsActive" className="fieldTitle">
                          <Radio.Group>
                            <label
                              className="btn btn-primary col-md-2"
                              style={{ marginRight: '10px', marginBottom: '20px' }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="appType"
                                name="IsActive"
                                type="radio"
                                value={1}
                                style={{ width: '600px', color: 'white', fontWeight: '' }}
                              >
                                {' '}
                                Active
                              </Radio>
                            </label>
                            <label
                              className="btn btn-primary col-md-2"
                              style={{ marginRight: '10px', marginBottom: '20px' }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="appType"
                                name="IsActive"
                                type="radio"
                                value={0}
                                style={{ width: '300px', color: 'white' }}
                              >
                                InActive
                              </Radio>
                            </label>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <Form.Item label={''} className="fieldTitle">
                      <Button
                        type="link"
                        icon={<FileExcelFilled />}
                        style={{ float: 'right', fontSize: '30px', color: 'green' }}
                        onClick={handleDownload}
                      ></Button>
                      &nbsp; &nbsp;
                      <Button
                        type="primary"
                        onClick={handleSource}
                        style={{ float: 'right', marginRight: '5px' }}
                      >
                        {'CREATE SOURCE'}
                      </Button>
                      &nbsp; &nbsp;
                      <Button
                        type="primary"
                        onClick={handleReset}
                        style={{ float: 'right', marginRight: '10px' }}
                      >
                        {'CLEAR'}
                      </Button>
                      &nbsp; &nbsp;
                      <Button
                        htmlType="submit"
                        type="primary"
                        style={{ float: 'right', marginRight: '10px' }}
                      >
                        {'SEARCH'}
                      </Button>
                      {/* <Button
                        type="primary"
                        style={{ float: 'right', marginRight: '10px' }}
                        onClick={handleDownload}
                      >
                        {'Download'}
                      </Button> */}
                    </Form.Item>
                  </div>
                </Form>
              </div>
              <SourceList filter={{ ...filter }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Source;
